module.exports = __webpack_public_path__ + "static/media/DownloadWhite.0fbbc1b4.svg";